import { FC } from "react";
import PrimaryButton from "components/buttons/PrimaryButton";
import SecondaryButton from "components/buttons/SecondaryButton";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import apiNyckelGuide from "./api-nyckel-guide.pdf";
import { MicroLabel, StatusBadge } from "../ui";

interface Props {
  nvKey?: string;
  nvSecret?: string;
  onOpenModal: () => void;
}

const GuideLink = () => (
  <a
    href={apiNyckelGuide}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700"
  >
    Guide för att skapa API-nycklar
    <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" />
  </a>
);

export const NaturvardsverketApiKeysSection: FC<Props> = ({
  nvKey,
  nvSecret,
  onOpenModal,
}) => {
  const hasSetKeyAndSecret = !!nvKey && !!nvSecret;

  return (
    <div className="rounded-xl border border-slate-200 p-4">
      <div className="flex items-center justify-between gap-3">
        <h4 className="text-sm font-semibold text-slate-900">API-nycklar</h4>
        <StatusBadge color={hasSetKeyAndSecret ? "green" : "amber"} dot>
          {hasSetKeyAndSecret ? "Konfigurerad" : "Saknas"}
        </StatusBadge>
      </div>

      {hasSetKeyAndSecret ? (
        <div className="mt-4 space-y-3">
          <div className="rounded-lg bg-slate-50 p-3 ring-1 ring-inset ring-slate-100">
            <MicroLabel>API Key</MicroLabel>
            <div className="mt-1 break-all font-mono text-sm text-slate-900">
              {nvKey}
            </div>
          </div>
          <div className="rounded-lg bg-slate-50 p-3 ring-1 ring-inset ring-slate-100">
            <MicroLabel>API Secret</MicroLabel>
            <div className="mt-1 break-all font-mono text-sm text-slate-900">
              {nvSecret}
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-4 pt-1">
            <SecondaryButton size="small" onClick={onOpenModal}>
              Uppdatera API-nycklar
            </SecondaryButton>
            <GuideLink />
          </div>
        </div>
      ) : (
        <div className="mt-3 space-y-3">
          <p className="max-w-prose text-sm text-slate-500">
            API-nycklar har inte konfigurerats än. För att rapportera avfall
            behöver ni skaffa en API-nyckel hos Naturvårdsverket – det tar bara
            några minuter.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <PrimaryButton size="small" onClick={onOpenModal}>
              Ange API-nycklar
            </PrimaryButton>
            <GuideLink />
          </div>
        </div>
      )}
    </div>
  );
};
